export function pickLocale(content, language) {
  return String(language || '').toLowerCase().startsWith('fr') ? content.fr : content.en
}
